export default "__VITE_ASSET__8ef9d39c__"